// instruction: how to make custom component: https://edupala.com/custom-component-in-ionic/
// gebruik: https://stackoverflow.com/questions/64643390/the-component-is-declared-by-more-than-one-ngmodule

import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { GlobalService } from '../../global.service';
import { AjaxService } from '../../ajax.service';

@Component({
    selector: 'app-imageview',
    templateUrl: './imageview.component.html',
    styleUrls: ['./imageview.component.scss'],
    standalone: false
})
export class ImageviewComponent implements OnChanges {

    @Input() open: boolean;
    @Input() imgs: any;
    @Input() idx: number;
    @Input() ordnr: string; // for edit description
    @Input() baseSub: string;
    @Input() currSub: string;
    @Output() close = new EventEmitter();
    @ViewChild('descrInput', {static: false}) inputEl: ElementRef;

    editDescr = false;

    sliderOpts = {
        zoom: {
            maxRatio: 4
        }
    };

    constructor(
        public globals: GlobalService,
        private ajax: AjaxService,
    ) { }

    onResize() {
        const ngxImg = Array.from(document.getElementsByClassName('ngxImageZoomThumbnail') as HTMLCollectionOf<HTMLElement>);
        if (ngxImg.length > 0) {
            ngxImg[0].style.maxHeight = window.innerHeight + 'px';
            ngxImg[0].style.maxWidth = window.innerWidth + 'px';
        }
    }

    ngOnChanges() {
        this.onResize();
    }

    startDescrEdit() {
        if (this.ordnr) {
            this.editDescr = true;
            setTimeout(() => this.inputEl.nativeElement.focus());
        }
    }

    endDescrEdit() {
        this.editDescr = false;
        if (this.currSub === undefined) { this.currSub=''; }
        if (this.baseSub === undefined) { this.baseSub=''; }
        console.log('imageview-endDescrEdit:', this.ordnr, this.baseSub + this.currSub, this.imgs[this.idx].filename);
        this.ajax.get('SetDocTxt', {
            table: 'orders',
            value: this.ordnr,
            subdir: this.baseSub + this.currSub,
            filename: this.imgs[this.idx].filename,
            txt: this.imgs[this.idx].txt
        });
    }

}
